import shuffle from 'lodash/shuffle';
import {
  MediaData,
  NumberMediaData,
  DragAndDropNodeData,
  DragAndDropData,
} from '../../../types/quiz';
import { getQuestion, parseMainExp } from './utils';

/**
 * DragAndDrop.
 */
export const mapDragAndDrop = ({
  data,
  mediaData,
}: {
  data: DragAndDropNodeData;
  mediaData: MediaData<NumberMediaData[]>;
}): DragAndDropData => {
  const originalAnswers = data.a.map(({ v, r, exp }) => ({
    explanation: parseMainExp<NumberMediaData[]>(exp, mediaData) || '',
    text: parseMainExp<NumberMediaData[]>(v, mediaData) || '',
    isCorrect: r === 'true',
  }));

  return {
    question: getQuestion<NumberMediaData[]>(data.q, mediaData),
    mainExplanation: parseMainExp<NumberMediaData[]>(data.e, mediaData) || '',
    keyTakeaway: parseMainExp<NumberMediaData[]>(data.kp, mediaData) || '',
    answers: originalAnswers,
    shuffledAnswers: shuffle([...originalAnswers]),
    optionsText: data.optionsText,
    answersText: data.answersText,
    ordered: data.ordered === 'true',
  };
};
